@if(buttonActionType === 'link') { @if(externalLink){
<a
  class="button-link"
  [id]="id ?? label"
  [ngClass]="getClassObject()"
  [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
  [type]="'button'"
  [href]="url"
  (keyup)="onKeyUpLink($event)"
  [target]="'__blank'"
  [rel]="'noopener noreferrer'"
  (focus)="focusEvent.emit($event)"
>
  <div class="button-container" [ngStyle]="{ 'flex-direction': getTextAlign() }">
    @if(iconSvg){
    <img class="icon-svg" [src]="iconSvg" alt="Icon" />
    } @if(iconName){
    <span
      class="material-symbols-outlined"
      [ngClass]="getIconClassObject()"
      [attr.aria-hidden]="true"
      [attr.role]="'presentation'"
      [attr.data-icon]="iconName"
    >
    </span>
    } @if(label){
    {{ label }}
    }
  </div>
</a>
} @if(!externalLink){
<a
  class="button-link"
  [id]="id ?? label"
  [ngClass]="getClassObject()"
  [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
  [type]="'button'"
  [routerLink]="!externalLink ? url : null"
  [attr.aria-label]="ariaLabel"
  [attr.role]="role"
  (keyup)="onKeyUpLink($event)"
  (focus)="focusEvent.emit($event)"
>
  <div class="button-container" [ngStyle]="{ 'flex-direction': getTextAlign() }">
    @if(iconSvg){
    <img class="icon-svg" [src]="iconSvg" alt="Icon" />
    } @if(iconName){
    <span
      class="material-symbols-outlined"
      [ngClass]="getIconClassObject()"
      [attr.aria-hidden]="true"
      [attr.role]="'presentation'"
      [attr.data-icon]="iconName"
    >
    </span>
    } @if(label){
    {{ label }}
    }
  </div>
</a>
} } @if(buttonActionType === 'download' && file){
<a
  class="button-link"
  [id]="id ?? label"
  [ngClass]="getClassObject()"
  [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
  [type]="'button'"
  [href]="getUrlFile(this.file.file.url)"
  (keyup)="onKeyUpDownload($event)"
  (click)="downloadClickEvent($event)"
>
  <div class="button-container" [ngStyle]="{ 'flex-direction': getTextAlign() }">
    @if(iconSvg){
    <img class="icon-svg" [src]="iconSvg" alt="Icon" />
    } @if(iconName){
    <span
      class="material-symbols-outlined"
      [ngClass]="getIconClassObject()"
      [attr.aria-hidden]="true"
      [attr.role]="'presentation'"
      [attr.data-icon]="iconName"
    >
    </span>
    } @if(label){
    {{ label }}
    }
  </div>
</a>

}
